const scriptEl = document.currentScript as HTMLScriptElement | null;

/**
 * The `?v2` flag was requested by product during Visa SDK v2 rollout.
 *
 * It serves TWO purposes:
 *
 * 1. Bypass metadata rollout mechanism to ensure v2 is served (as we are in the
 *    v2 codebase, this bypass has presumably already occured)
 * 2. Defaults dcfExperience to "integrated" if
 *    `dpaTransactionOptions.customInputData.checkoutOrchestrator` is undefined
 */
// script src contains `?visaSrci` in Visa-SRCi integrations
export const isVisaSrci = scriptEl?.src.includes('?visaSrci');
export const v2 = scriptEl?.src.includes('?v2');
export const vsb = scriptEl?.src.includes('vsb');
